import { useFormikContext } from 'formik';
import React from 'react';
import PropTypes from 'prop-types';
import { NumberField } from 'Shared/form/NumberField';
import CommonPatientFieldWrapper from 'App/components/PatientForm/components/CommonPatientFieldWrapper';

const propTypes = {
    row: PropTypes.shape({
        id: PropTypes.string.isRequired,
    }).isRequired,
};

const defaultProps = {};

function CopayAmountCell({ row }) {
    const {
        values: { disableInputs },
    } = useFormikContext();
    return (
        <CommonPatientFieldWrapper fieldName="referralBiCopayAmt">
            {(commonProps) => (
                <NumberField
                    {...commonProps}
                    fieldName={`medications[${row.id}].data.copayAmount`}
                    disabled={disableInputs || commonProps.disabled}
                    placeholder="Copay Amount"
                    min={0}
                    prefixAddon="$"
                />
            )}
        </CommonPatientFieldWrapper>
    );
}

CopayAmountCell.propTypes = propTypes;
CopayAmountCell.defaultProps = defaultProps;

export default CopayAmountCell;
